import { Component, OnDestroy, OnInit } from '@angular/core';
import { detect } from 'detect-browser';
import { Subscription } from 'rxjs';
import { ProjectService } from '../core/services/project.service';
import { MainView } from '../working-table/visualisation/main-view';

@Component({
    selector: 'gl-main-container',
    templateUrl: './main-container.component.html',
    styleUrls: ['./main-container.component.scss'],
    standalone: false
})
export class MainContainerComponent implements OnInit, OnDestroy {
  public workingTable = null;
  public isMobile: boolean;
  private subscription: Subscription;

  constructor(private projectService: ProjectService) {
    const browser = detect();
    this.isMobile =
      browser.os === 'iOS' ||
      browser.os === 'Android OS' ||
      browser.os === 'BlackBerry OS' ||
      browser.os === 'Windows Mobile' ||
      browser.os === 'Amazon OS';
  }

  ngOnInit(): void {
    this.subscription = this.projectService.$workingTable.subscribe(
      (mainView: MainView) => (this.workingTable = mainView),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
